import axios from "axios";
import authService from "./auth.service";

const api = axios.create();

api.interceptors.request.use((req) => {
  const token = authService.getToken();

  req.params = req.params || {};

  if (token) {
    req.params.token = token;
  }

  return req;
});

export default api;
